import ZusDeclarationPackageApi from '../../../../../api-v2/bookkeeping/zus-declarations-package.js';
import notifyError from '../../../../procedures/notify-error';
import notifySuccess from '../../../../procedures/notify-success';
import action from '../../../abstract/action.js';

export default action({
  label: 'Stwórz paczkę',
  icon: 'PackageIcon',
  main: () => false,
  render: ({ item }) => item.zusdeclarationspackages === null,
  handle: async ({ $router, $vs, item }) => {
    $vs.loading();

    let data = {
      zusdeclarationspackage: {
        month: item.month,
        year: item.year,
        declaration_id: item.id,
      },
    };

    await ZusDeclarationPackageApi.store({ zuspackage: data })
      .then(
        ({ data }) => {
          notifySuccess({
            $vs,
            text: 'Zestaw został zapisany',
          });
          $vs.loading.close();
          $router.push('/zus/packages');
        },
      ).catch((error) => {
        $vs.loading.close();
        if (!(error.response && error.response.status && 422 === error.response.status)) {
          throw error;
        }
        if (error.response && error.response.data) {
          notifyError({
            $vs,
            text: error.response.data,
          });
        }
        notifyError({
          $vs,
          text: 'Zestaw nie został zapisany',
        });
      });
  },

});
